<template>
  <delivery-in-process 
  ref="deliveryInProcess" 
  v-if="delivery.completed === 0" 
  :id="id"
  @goBack="goBack"
  @onComplete="onComplete">
  </delivery-in-process>
  <complete-delivery 
  v-else-if="delivery.completed === 1" 
  :id="id"
  @goBack="goBack">
  </complete-delivery>
</template>

<script>
import DeliveryInProcess from './DeliveryInProcess'
import DeliveryComplete from './DeliveryComplete'
import GoBack from '@/mixins/GoBack'

export default {
  components: {
    'complete-delivery': DeliveryComplete,
    'delivery-in-process': DeliveryInProcess
  },
  mixins: [GoBack],
  props: ['id'],
  data () {
    return {
      delivery: {},
      previousPage: '/deliveries'
    }
  },
  methods: {
    onComplete () {
      this.fetchDelivery()
    },
    fetchDelivery () {
      this.$axios.get(`/deliveries/${this.id}`)
        .then(delivery => {
          this.delivery = delivery.data
        })
        .catch(error => this.$root.$errorSnackbar(error))
    }
  },
  created () {
    this.fetchDelivery()
  },
  beforeRouteLeave (to, from, next) {
    if (this.delivery.completed === 0) {
      this.$refs.deliveryInProcess.beforeRouteLeaveFaker(to, from, next)
    } else {
      next()
    }
    /* const answer = window.confirm('Do you really want to leave? you have unsaved changes!')
    if (answer) {
      next()
    } else {
      next(false)
    } */
  }
}
</script>

<style scoped>
</style>
